import type { SxProps, Theme } from '@mui/material/styles';

type OdometerModalStyleMap = {
    content: SxProps<Theme>
    infoAlert: SxProps<Theme>
    actions: SxProps<Theme>
};

export const odometerModalStyles: OdometerModalStyleMap = {
    content: { display: 'flex', flexDirection: 'column', gap: 2, pt: 1 },
    infoAlert: { fontSize: 12 },
    actions: { px: 3, pb: 2 },
};
